import { useEffect, useState } from "react";
import { Loader2, Copy, Check, FileCode2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function LeadAdfDialog({ lead, onClose }) {
  const [xml, setXml] = useState("");
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!lead) return;
    setLoading(true);
    setXml("");
    setCopied(false);
    api
      .get(`/leads/${lead.id}/adf`)
      .then(({ data }) => setXml(data.xml))
      .catch(() => setXml("Failed to load ADF payload."))
      .finally(() => setLoading(false));
  }, [lead]);

  const copy = async () => {
    await navigator.clipboard.writeText(xml);
    setCopied(true);
  };

  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0F111A] border-[#2A2E3D] text-white max-w-2xl max-h-[85vh] flex flex-col" data-testid="lead-adf-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading font-extrabold flex items-center gap-2">
            <FileCode2 className="h-5 w-5 text-[#0A8CF2]" /> ADF XML — {lead?.customer_name}
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Exact payload emailed to your CRM inbox. Matched specialist is in the vendor contact block.
          </DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-[#0A8CF2]" /></div>
        ) : (
          <pre data-testid="lead-adf-xml" className="text-xs font-mono-tech text-slate-300 bg-slate-950 border border-slate-800 rounded-lg p-4 overflow-auto flex-1 min-h-0 whitespace-pre-wrap">{xml}</pre>
        )}
        <Button variant="outline" onClick={copy} disabled={!xml} data-testid="copy-adf-btn" className="self-end border-slate-700 bg-slate-900/50 hover:bg-slate-800 text-slate-200">
          {copied ? <Check className="mr-2 h-4 w-4 text-emerald-400" /> : <Copy className="mr-2 h-4 w-4" />}
          {copied ? "Copied" : "Copy XML"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
